var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.668 37.7004C20.2591 34.2024 12.1943 20.7935 9.27935 18.3644C8.16194 17.4899 6.99595 16.6154 5.78138 15.8381H11.0769C12.2429 17.587 31.2875 45.7166 31.6275 46.7854C32.7935 46.3968 33.9595 45.9109 35.0283 45.3279C34.9798 44.8421 34.1053 41.7328 33.9595 41.1498C32.3077 34.5425 29.8785 30.753 25.8462 25.3117C24.1457 22.9798 22.6397 20.5506 20.0648 19.1903C19.8704 19.0931 19.3846 18.753 19.2389 18.6073H24C24.1943 18.996 25.7004 20.9393 26.0405 21.4251C30.6559 28.3239 35.0769 35.2713 39.6923 42.17C40.664 41.2955 41.587 40.4211 42.413 39.4008C42.1215 38.6721 41.7814 37.9433 41.6356 37.5547C40.0324 33.2794 36.7773 26.0891 33.4251 23.1255C33.2308 22.9798 32.9879 22.834 32.8907 22.6397H35.1741C38.0405 26.8664 40.5182 30.3158 43.2389 34.8826C43.336 35.0283 43.8704 35.9028 44.3563 36.6802C46.6397 32.9879 48 28.664 48 24C48 10.7368 37.2632 0 24 0C10.7368 0 0 10.7368 0 24C0 37.2632 10.7368 48 24 48C24.3887 48 24.7287 47.9514 25.1174 47.9514C25.0202 46.2024 22.2996 39.2551 21.668 37.7004Z",
    fill: "#181C6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e57f33f4133fa5ddc3d6186e0c95b06c.svg";
export { ForwardRef as ReactComponent };